import EDRimg from "public/cyber-security/edrmdrxdr/EDR.png";
import MDRimg from "public/cyber-security/edrmdrxdr/MDR.png";
import XDRimg from "public/cyber-security/edrmdrxdr/XDR.png";

export const ADVANTAGES_IMAGES = [EDRimg, MDRimg, XDRimg];
